// apps/dashboard/src/lib/anon-id.ts
import Cookies from 'js-cookie';
import { clientCookieAttributes } from './cookies';

/**
 * Anonymous cart-tracking id. The frontend owns this cookie — the API never sets it — so
 * a visitor's cart can be attributed to them before they ever log in. Shares the same
 * apex-domain resolution as aks_session/aks_cart (see ./cookies), so it reaches
 * *.aksademia.com and gets forwarded to the API through the proxy's Cookie header.
 * Not httpOnly: only JS needs to read/write it.
 */
export const ANON_ID_COOKIE = 'aks_anon';

// ~400 days — mirrors GA4's max first-party cookie lifetime, comfortably longer than any
// realistic purchase-consideration window.
const ANON_ID_MAX_AGE_DAYS = 400;

/**
 * Reads the `aks_anon` cookie, minting and persisting a new uuid if absent. Client-only —
 * server render / build has no cookie jar to mint into, so this no-ops there rather than
 * throwing.
 */
export function ensureAnonId(): string {
  if (typeof document === 'undefined') return '';

  const existing = Cookies.get(ANON_ID_COOKIE);
  if (existing) return existing;

  const id = crypto.randomUUID();
  Cookies.set(ANON_ID_COOKIE, id, clientCookieAttributes(ANON_ID_MAX_AGE_DAYS));
  return id;
}
